import queryString from 'query-string';

export default function(searchQueries) {
    let query = '';

    searchQueries.forEach(function(item, index) {
        query += queryString.stringify({
                    [item.attribute.value]: item.innerFields.map((field, index) =>
                                                (field.connection ? `${field.connection};` : '') +
                                                (field.relation === 'IS_EMPTY' || field.relation === 'CONTAINS_ANYTHING'  ?
                                                    (`${field.relation}`) :
                                                    (`${field.relation}:` + getValue(field, item.attribute.type)))
                                                ) +
                                                (index !== searchQueries.length - 1 ? '&' : '')
                }, {arrayFormat: 'index'});
    });

    return decodeURIComponent(query);
};

const getValue = (field, type) => {
    if (type === 'date' || type === 'year') {
        return (field.valueFrom ? field.valueFrom : "*") + "-" + (field.valueTo ? field.valueTo : "*");
    }

    return field.value;
};



// WEBPACK FOOTER //
// ./src/scripts/SearchResultsQueryBuild.js